export enum ActivityType {
  EVENT = "Event",
}

